/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pw_exclude_ambiguous = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exclude ambiguous (Il1O0o)`)
};

const es_pw_exclude_ambiguous = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir ambiguos (Il1O0o)`)
};

const de_pw_exclude_ambiguous = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehrdeutige Zeichen ausschließen (Il1O0o)`)
};

const nl_pw_exclude_ambiguous = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sluit dubbelzinnige uit (Il1O0o)`)
};

const fr_pw_exclude_ambiguous = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exclure ambiguïté (Il1O0o)`)
};

const it_pw_exclude_ambiguous = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escludi ambigui (Il1O0o)`)
};

const pt_br2_pw_exclude_ambiguous = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir ambíguos (Il1O0o)`)
};

const pt_pw_exclude_ambiguous = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir ambíguos (Il1O0o)`)
};

const ja_pw_exclude_ambiguous = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`曖昧な文字を除外 (Il1O0o)`)
};

const zh_pw_exclude_ambiguous = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排除易混淆字符 (Il1O0o)`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pw_exclude_ambiguous = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pw_exclude_ambiguous(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pw_exclude_ambiguous", locale)
	if (locale === "en") return en_pw_exclude_ambiguous(inputs)
	if (locale === "es") return es_pw_exclude_ambiguous(inputs)
	if (locale === "de") return de_pw_exclude_ambiguous(inputs)
	if (locale === "nl") return nl_pw_exclude_ambiguous(inputs)
	if (locale === "fr") return fr_pw_exclude_ambiguous(inputs)
	if (locale === "it") return it_pw_exclude_ambiguous(inputs)
	if (locale === "pt-BR") return pt_br2_pw_exclude_ambiguous(inputs)
	if (locale === "pt") return pt_pw_exclude_ambiguous(inputs)
	if (locale === "ja") return ja_pw_exclude_ambiguous(inputs)
	return zh_pw_exclude_ambiguous(inputs)
};